import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';

export type AddonKey = 'help' | 'feedback' | 'xero';

/** Add-on key → on/off for every institution. Mirrors AddonService.globalStates (no row = on). */
export type AddonStates = Record<AddonKey, boolean>;

export const ADDON_KEYS: AddonKey[] = ['help', 'feedback', 'xero'];

export const AddonService = {
    async getGlobal(): Promise<AddonStates> {
        const response = await axios.get<AddonStates>(ENDPOINTS.ADDONS.GLOBAL, { headers: AuthService.getAuthHeader() });
        return response.data;
    },

    async platformList(): Promise<AddonStates> {
        const response = await axios.get<AddonStates>(ENDPOINTS.ADDONS.PLATFORM, { headers: AuthService.getAuthHeader() });
        return response.data;
    },

    async platformUpdate(key: AddonKey, enabled: boolean): Promise<AddonStates> {
        const response = await axios.put<AddonStates>(ENDPOINTS.ADDONS.PLATFORM_UPDATE(key), { enabled }, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },
};
